import { memo, useEffect, useState } from "react";
import { AddressMap } from "ui/components/Map/AddressMap";
import { geocodeAddress } from "ui/components/Map/geocode";
import { LocationMapProps } from "./types";

interface Position {
  lat: number;
  lng: number;
}

/**
 * Karta lokacije na oglasu — poslovnice ili ručno upisane adrese.
 *
 * Koordinate stižu s poslovnice kad ih ima; ručni unos i starije poslovnice ih nemaju, pa
 * se adresa jednom geokodira. Kad ni to ne uspije, karta se izostavlja — adresa iznad ostaje.
 */
const LocationMap: React.FC<LocationMapProps> = ({ address, latitude, longitude }) => {
  const [position, setPosition] = useState<Position | null>(
    latitude != null && longitude != null ? { lat: latitude, lng: longitude } : null
  );

  useEffect(() => {
    if (position || !address) return;

    let isCancelled = false;

    geocodeAddress(address).then((result) => {
      if (isCancelled || !result) return;

      setPosition({ lat: result.latitude, lng: result.longitude });
    });

    return () => {
      isCancelled = true;
    };
  }, [address, position]);

  if (!position) return null;

  return (
    <div className="relative mt-3 h-[180px] rounded-sm overflow-hidden border border-slate-200">
      <AddressMap initialPosition={position} hideAutocomplete />
      {/* Ovo je prikaz, ne unos — sloj guta klikove da AddressMap ne premješta pin. */}
      <div className="absolute inset-0 z-20" />
    </div>
  );
};

export default memo(LocationMap);
